import { FC, memo, useMemo } from "react";
import { Theme } from "@mui/material";
import { getCleanDialogGridColumns } from "./cleanDialogGridColumns";
import { DataGrid } from "../../../../../../../../storybook/data-grid/DataGrid";
import { ResourceType } from "../../../../../../../../services/cloudchipr.api";
import { CleanResourcesDataType } from "../../../utils/types";

interface CleanResourceGridProps {
  resourceType: ResourceType;
  data: CleanResourcesDataType;
}

export const CleanResourceGrid: FC<CleanResourceGridProps> = memo(
  ({ resourceType, data }) => {
    const columns = useMemo(
      () => getCleanDialogGridColumns(resourceType),
      [resourceType],
    );

    if (!data) {
      return null;
    }

    return (
      <DataGrid
        toolbar
        data={data}
        styles={styles}
        columns={columns}
        columnResizeMode="onEnd"
        columnSorting={sortingConfig}
      />
    );
  },
);

const sortingConfig = { initialSort: [{ id: "price_per_month", desc: true }] };
const styles = {
  tableHeaderRow: {
    top: 0,
    position: "sticky",
    bgcolor: "grey.200",
    zIndex: (theme: Theme) => theme.zIndex.appBar - 1,
  },
  tableContainer: {
    maxHeight: 380,
    "& td": { py: 1 },
    px: 3,
  },
  tableRow: {
    "&:last-of-type td": {
      border: `none`,
    },
  },
};
